import { funcType } from '@lc/types/Misc';

import { Contract, ContractVerbose } from './types';

export function createCardContract(
	id: number,

	title: string = ``,
	goal: string = ``,
	funding: string = ``,
	pentaly: string = ``,
	flavor: string = ``,

	modifier: string = ``,
	due: string = `next`,

	// set to true if a player is targeted either at card play or contract resolution
	initialTarget: boolean = false,
	resolutionTarget: boolean = false, // decision?

	requireTarget: boolean = false,
	requireSource: boolean = false,
	requireDecision: boolean = false
): Contract {
	const cost = 0;
	const type = 'Contract';

	return {
		id,
		cost,
		type,
		title,
		goal,
		funding,
		pentaly,
		flavor,

		modifier,
		due,

		initialTarget,
		resolutionTarget,

		requireTarget,
		requireSource,
		requireDecision,
	};
}

export function createCardContractVerbose(
	contract: Contract,
	actionCondition: funcType,
	actionFund: funcType = () => ({}),
	actionPenalty: funcType = () => ({})
): ContractVerbose {
	return {
		...contract,
		actionCondition,
		actionFund,
		actionPenalty,
	};
}
